import React from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

function getInitials(firstname, lastname, username) {
  if (firstname && lastname) return `${firstname[0]}${lastname[0]}`.toUpperCase();
  if (username) return username[0].toUpperCase();
  return '?';
}

export default function Avatar({ user, size = 'md', className = '' }) {
  const sizeMap = {
    xs:  'w-6 h-6 text-[10px]',
    sm:  'w-8 h-8 text-xs',
    md:  'w-11 h-11 text-base',
    lg:  'w-14 h-14 text-xl',
    xl:  'w-20 h-20 text-2xl',
  };
  const sizeClass = sizeMap[size] || sizeMap.md;
  const initials = getInitials(user?.firstname, user?.lastname, user?.username);
  const avatarUrl = user?.avatar_url ? `${API_URL}${user.avatar_url}` : null;

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={user?.username || 'Avatar'}
        className={`${sizeClass} rounded-full object-cover flex-shrink-0 border border-white/20 ${className}`}
        onError={(e) => {
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'flex';
        }}
      />
    );
  }

  return (
    <div className={`${sizeClass} rounded-full bg-ocean-100 flex items-center justify-center font-bold text-ocean-600 flex-shrink-0 ${className}`}>
      {initials}
    </div>
  );
}

export function AvatarWithFallback({ user, size = 'md', className = '' }) {
  const sizeMap = {
    xs:  'w-6 h-6 text-[10px]',
    sm:  'w-8 h-8 text-xs',
    md:  'w-11 h-11 text-base',
    lg:  'w-14 h-14 text-xl',
    xl:  'w-20 h-20 text-2xl',
  };
  const sizeClass = sizeMap[size] || sizeMap.md;
  const initials = getInitials(user?.firstname, user?.lastname, user?.username);
  const avatarUrl = user?.avatar_url ? `${API_URL}${user.avatar_url}` : null;
  const [imgFailed, setImgFailed] = React.useState(false);

  if (avatarUrl && !imgFailed) {
    return (
      <img
        src={avatarUrl}
        alt={user?.username || 'Avatar'}
        className={`${sizeClass} rounded-full object-cover flex-shrink-0 border border-white/10 ${className}`}
        onError={() => setImgFailed(true)}
      />
    );
  }

  return (
    <div className={`${sizeClass} rounded-full bg-ocean-100 flex items-center justify-center font-bold text-ocean-600 flex-shrink-0 ${className}`}>
      {initials}
    </div>
  );
}
